import { render, staticRenderFns } from "./ModuleSidebar.vue?vue&type=template&id=44cc283d&"
import script from "./ModuleSidebar.vue?vue&type=script&lang=js&"
export * from "./ModuleSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports